const CATEGORIES = [
  { value: 'all', label: 'Все категории' },
  { value: 'celebrity', label: 'Знаменитости' },
  { value: 'newsworthy', label: 'Инфоповоды' },
];

export { CATEGORIES }; 